import { render, staticRenderFns } from "./golfCourse.vue?vue&type=template&id=91621932&scoped=true"
import script from "./golfCourse.vue?vue&type=script&lang=js"
export * from "./golfCourse.vue?vue&type=script&lang=js"
import style0 from "./golfCourse.vue?vue&type=style&index=0&id=91621932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91621932",
  null
  
)

export default component.exports